var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cs-segment',{staticClass:"cs-segment-footer",attrs:{"component":"footer"}},[_c('cs-container',{staticClass:"is-fullwidth"},[_c('div',{staticClass:"navigation"},[_c('cs-links',{attrs:{"data":_vm.$store.state.navigation.footer}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }